import { amber, green, orange, red } from "@mui/material/colors";
import Flx from "../../layout/Flx";
// src/components/LoanFilesTable/hooks/useColumnDefs.js
import {
  AutoAwesomeOutlined,
  CheckOutlined,
  ErrorOutline,
  GavelOutlined,
  HourglassEmpty,
  HourglassEmptyOutlined,
  ManageSearchOutlined,
} from "@mui/icons-material";
import isNil from "lodash/isNil";
import { useMemo } from "react";
import { useSelector } from "react-redux";

const CellRendererLoanFileStatus = ({ params, editing }) => {
  let status = params?.data?.documentStatus;
  let iconValue = null;

  const styles = useMemo(() => {
    const baseStyles = {
      color: "inherit",
      background: null,
      borderLeft: null,
      fontSize: "11px",
    };

    if (
      status === "Initial Reviewed" ||
      status === "Legal Reviewed" ||
      status === "Pending Review"
    ) {
      baseStyles.background = orange[50];
      // baseStyles.borderLeft = `2px solid ${orange[100]}`;
    }
    if (
      status === "Expired" ||
      status === "Rejected" ||
      status === "Incomplete"
    ) {
      baseStyles.background = red[50];
      baseStyles.color = red[900];
      // baseStyles.borderLeft = `2px solid ${red[100]}`;
    }

    if (status === "Accepted") {
      baseStyles.color = green[900];
      baseStyles.background = green[50];
      // baseStyles.borderLeft = `2px solid ${green[100]}`;
    }
    return baseStyles;
  }, [status]);
  // const formattedUserName = getUserFullNameFromEmail(users, updatedByUserEmail);

  if (params?.data?.documentStatus === "New Upload") {
    iconValue = <AutoAwesomeOutlined className="thin" />;
  }
  if (params?.data?.documentStatus === "Initial Reviewed") {
    iconValue = <ManageSearchOutlined className="thin" />;
  }
  if (params?.data?.documentStatus === "Legal Reviewed") {
    iconValue = <GavelOutlined className="thin" />;
  }
  if (params?.data?.documentStatus === "Pending Review") {
    iconValue = <HourglassEmpty className="thin" />;
  }
  if (params?.data?.documentStatus === "Expired") {
    iconValue = <HourglassEmptyOutlined className="thin" />;
  }
  if (params?.data?.documentStatus === "Rejected") {
    iconValue = <ErrorOutline className="thin" />;
  }
  if (params?.data?.documentStatus === "Incomplete") {
    iconValue = <ErrorOutline className="thin" />;
  }
  if (params?.data?.documentStatus === "Accepted") {
    iconValue = <CheckOutlined className="thin" />;
  }

  return (
    <Flx
      ac
      sx={{ height: "100%", fontSize: "inherit" }}
      className="cell-renderer-file-status-root"
    >
      <Flx
        ac
        g={0.4}
        sx={{
          width: "max-content",
          borderRadius: "50px",
          px: 1.2,
          py: 0.4,
          flexGrow: 0,
          ...styles,
          height: "100%",
          ".MuiSvgIcon-root": {
            fontSize: "13px",
          },
        }}
      >
        {iconValue}
        <span
          className="cell-renderer-file-status--text"
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            lineHeight: "16px",
            fontSize: "inherit",
          }}
        >
          {status}
        </span>
      </Flx>
    </Flx>
  );
  // return (
  //   <Flx column gap={0} sx={{ width: "100%", overflow: "hidden" }}>
  //     <Flx
  //       ac
  //       g={0.4}
  //       sx={{
  //         ".MuiSvgIcon-root": {
  //           fontSize: "13px",
  //         },
  //       }}
  //     >
  //       {iconValue}
  //       <span
  //         style={{
  //           overflow: "hidden",
  //           textOverflow: "ellipsis",
  //           whiteSpace: "nowrap",
  //           lineHeight: "16px",
  //           fontSize: "12px",
  //         }}
  //       >
  //         {statusValue}
  //       </span>
  //     </Flx>
  //     {isNil(statusValue) ||
  //     statusValue === "New Upload" ||
  //     editing ||
  //     isNil(formattedUserName) ? null : (
  //       <span
  //         style={{
  //           lineHeight: "14px",
  //           fontWeight: 400,
  //           overflow: "hidden",
  //           textOverflow: "ellipsis",
  //           whiteSpace: "nowrap",
  //           fontSize: "9.4px",
  //         }}
  //       >
  //         By <span style={{ fontWeight: 400 }}>{formattedUserName}</span> on{" "}
  //         <span style={{ fontWeight: 400 }}>
  //           {formatDateTime(updatedByUserDate)}
  //         </span>
  //       </span>
  //     )}
  //   </Flx>
  // );
};

export default CellRendererLoanFileStatus;
